import { route } from '../constants/routePath';
import AxiosRequest from '../configs/api';
const OrderService = {};

OrderService.myOrderList = () => AxiosRequest.get(
    `/${route.pointRedemption}/api/v1/orderList/1?`,
  );
OrderService.trackOrder = (orderId) => AxiosRequest.get(
    `/${route.pointRedemption}/api/v1/orderTrack/${orderId}`,
  );

OrderService.tdsData = (grandTotal) => AxiosRequest.get(
    `/${route.pointRedemption}/api/v1/tds-calculation/tds?current_trans=${grandTotal}`,
  );

OrderService.panUpdate = (formData) => AxiosRequest.post(
    `/${route.pointRedemption}/api/v1/orders/upload/kyc`,
    formData,
  );

OrderService.cancelOrder = (payload) => AxiosRequest.post(
    `/${route.pointRedemption}/api/v2/orders/cancel`,
    payload,
  );

OrderService.myInfluencerOrderList = (payload) => AxiosRequest.post(
    `/${route.pointRedemption}/api/v1/orderList/my-influencer/${payload.contact_id}`,
    payload,
  );

  OrderService.getAddressList = (payload) => AxiosRequest.get(
    `/${route.pointRedemption}/api/v1/orders/pending-verification?hierarchy_id=${payload.userHierarchyId}&page_no=${payload.page_no}`,
    payload,
  );

  OrderService.panCheck = payload =>
    AxiosRequest.post(
      `/${route.pointRedemption}/api/v1/orders/check-pan`,
      payload,
    );

  OrderService.addressExcell = (hierId) =>
    AxiosRequest.get(
      `/${route.pointRedemption}/api/v1/orders/pending-verification/download?hierarchy_id=${hierId}`,
    );

  OrderService.uploadAddressExcel = (fd) =>
    AxiosRequest.postForm(
      `/${route.pointRedemption}/api/v1/orders/pending-verification/upload`,
      fd
    );


export default OrderService;